import api from '@/api'
import tool from '@/utils/tool'
import router from '@/router'
import {Toast} from "vant";

let token = tool.data.get('token');
if (!token) {
    token = tool.data.get('TOKEN');
    console.log('用户信息TOKEN', token);
}
else {
    console.log('用户信息token', token);
}

console.log('用户信息', tool.data.get('USER_INFO'));

export default {
    namespaced: true,
    state: {
        uid: tool.data.get('uid'),
        token: token,
        failuretime: tool.data.get('failuretime'),
        interval: tool.data.get('interval') || {},
        userInfo: tool.data.get('USER_INFO') || {},
        levelInfo: tool.data.get('levelInfo') || {},
        orders: tool.data.get('orders') || {},
        avatars: [
            'static/img/a01.png',
            'static/img/a02.png',
            'static/img/a03.gif',
            'static/img/a04.png',
            'static/img/a05.png',
            'static/img/a06.gif',
        ],
    },
    // 外部方法
    actions: {
        login({
            commit
        }, data) {
            commit('setData', data)
        },
        getUserInfo({
            commit,
            dispatch,
            state,
        }) {
            return new Promise((resolve, reject) => {
                var getUserInfo = function () {
                    api.post('user/index/getUserConfig')
                        .then((res) => {
                            if (res.code == 200) {
                                if (!res.data.userinfo.avatar && state.token) {
                                    if (res.data.userinfo && res.data.userinfo.nickname.indexOf('未知') < 0 && 'string' === typeof res.data.levelinfo.title && res.data.levelinfo.title.indexOf('未知') < 0) {
                                        dispatch('onEditAvatar');
                                    }
                                }
                                commit('setInfo', res.data);
                                resolve(res);
                            }
                            else {
                                resolve(res);
                            }
                        }).catch((err) => {
                            reject({code: 500, message: '获取用户信息失败, 服务器请求错误'});
                        });
                }
                getUserInfo();
            })
        },
        onEditAvatar({
            state
        }) {
            console.log(state.avatars);
            if (state && Array.isArray(state.avatars)) {
                let arr = state.avatars
                let ranDom = function (m, n) {
                    return Math.ceil(Math.random() * (n - m + 1) + m - 1)
                }
                let avatar = state.avatars[ranDom(0, arr.length - 1)]

                api.post('user/index/onEditAvatar', {
                    avatar: avatar
                })
            }
        }
    },
    // 获取数据
    getters: {
        isLogin: (state) => {
            let retn = false
            if (state.token != null && 'object' === typeof state.userInfo && state.userInfo.uid) {
                retn = true
                // let unix = Date.parse(new Date())
                // if (unix < state.failuretime) {
                //     retn = true
                // }
            }
            return retn
        }
    },
    // 内部设置方法
    mutations: {
        setData(state, data) {
            let failuretime = data.expiretime ? (data.expiretime * 1000) : (new Date()).getTime() + 86400 * 7 * 1000
            tool.data.set('token', data.token);
            tool.data.set('TOKEN', data.token);
            tool.data.set('failuretime', failuretime);
            state.token = data.token
            state.failuretime = failuretime
        },
        setInfo(state, data) {

            if (data.userinfo && 'object' === typeof data.userinfo && Object.keys(data.userinfo).some(item => item == 'uid' && data.userinfo[item]) && data.userinfo['username'] !== 'unknown') {
                state.userInfo = data.userinfo
                state.levelInfo = data.levelinfo
                state.orders = data.orders
                state.uid = data.userinfo.uid
                // console.log('setInfo', data.userinfo.nickname);
                tool.data.set('uid', data.userinfo.uid || null);
                tool.data.set('USER_INFO', data.userinfo);
                tool.data.set('levelInfo', data.levelinfo);
                tool.data.set('orders', data.orders);
            }
            else {
                // 清除数据
                state.userInfo = data.userinfo
                state.levelInfo = data.levelInfo
                state.orders = {}
                state.uid = 0
                // console.log('setInfo', data.userinfo.nickname);
                tool.data.remove('uid');
                tool.data.remove('TOKEN',);
                tool.data.remove('token');
                tool.data.remove('USER_INFO',);
                tool.data.remove('levelInfo');
                tool.data.remove('orders');
                // if (router.app.$route.path.indexOf('/user') > -1) {
                //     if (router.app.$route.path.indexOf('/user/index') < 0 && router.app.$route.path.indexOf('/user/order/index') < 0 && router.app.$route.path.indexOf('/user/kefu') < 0) {
                //         router.app.$router.push({
                //             path: '/user/login'
                //         })
                //     }
                // }
            }

            // console.log('userInfo', tool.data.get('userInfo'), state);
        },
        setUserInfo(state, data) {
            state.userInfo = data
            state.uid = data.uid
            tool.data.set('userInfo', data);
        },
        setLevelInfo(state, data) {
            state.levelInfo = data
        },
        setOrders(state, data) {
            state.orders = data
        },
        setUid(state, uid) {
            state.uid = uid
        },
        logout(state) {
            clearInterval(state.interval)
            tool.data.remove('interval');
            tool.data.remove('userInfo');
            tool.data.remove('token');
            tool.data.remove('failuretime');

            api.post('index/v1/store/index/logout', {}, {
                loading: false,
            }).then((res) => {
                if (res.code == 0) {
                    Toast.success('退出登录成功，稍后跳转~')
                    setTimeout(function () {
                        router.app.$router.push({
                            path: '/index'
                        })
                    }, 1000)
                }
            }).catch((err) => {
                Toast.success('退出登录成功，稍后跳转~')
                setTimeout(function () {
                    router.app.$router.push({
                        path: '/index'
                    })
                }, 1000)
            });
        }

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/token.js